import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { StockService } from 'app/sections/stocks/services/stock.service';
import { ToastService } from 'app/components/toasts/toasts.service';
import { Ticker } from 'app/interfaces/ticker';
import { Router } from '@angular/router';

@Component({
  selector: '[app-ticker]',
  templateUrl: './ticker.component.html',
  styleUrls: ['./ticker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TickerComponent implements OnInit, OnDestroy {
  
  public tickers$: Observable<any>;
  public tickerInput$ = new Subject<string>();
  private _unsubscribeAll: Subject<any>;
  public selectedTicker: string = null;
  public tikcerLoading: boolean = false;
  constructor(
    private _coreMenuService: CoreMenuService,
    private stockService: StockService,
    private toast:ToastService,
    private router: Router) { 
    this._unsubscribeAll = new Subject();
  }

  trackByFn(item: any) {
    return item.id;
  }

  loadTickers() {
    this.tickers$ = concat(
      of([]), // default items
      this.tickerInput$.pipe(
        filter(res => {
          return res !== null
        }),
        distinctUntilChanged(),
        debounceTime(400),
        tap(() => this.tikcerLoading = true),
        switchMap(term => {
          return this.getTickers(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.tikcerLoading = false)
          )
        })
      )
    );
  }

  getTickers(term: string = null): Observable<any> {
    if(term){
      return this.stockService.getStockPagination(1,6, term).pipe(
        map((resp: any) =>{
          if (resp.code == 1001){
            return resp.data;
          } else {
            return [];
          }
        })
      )
    } else {
      return of([]);
    }
  }

  ngOnInit(): void {
    this.loadTickers();
    this.stockService.selectedTickerInfo.pipe(takeUntil(this._unsubscribeAll)).subscribe((ticker: Ticker)=>{
      if(ticker){
        this.selectedTicker = ticker.ticker;
        const menu = this._coreMenuService.getMenu('main');
        this.enableMenu(menu);
        this._coreMenuService.setCurrentMenu('main')  
      }
    });
  }

  tickerChange(ticker){
    if(ticker){
      this.stockService.getTickerByName(ticker).toPromise().then((result:any)=>{
        if(result.code == 1001){
          const menu = this._coreMenuService.getMenu('main');
          this.enableMenu(menu);
          this._coreMenuService.setCurrentMenu('main');
          this.stockService.setTicker(result.data);
          this.router.navigateByUrl('/stock/summary');
        } else {
          this.toast.show(`This Ticker is for permium`, {
            delay: 2000,
            classname: 'bg-primary text-light',
            autohide: true
          });
        }
      });
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  enableMenu(menu){
    menu.forEach(element => {
      if(element.hasOwnProperty('disabled')){
        element.disabled = false;
      }
      if(element.hasOwnProperty('children')){
        this.enableMenu(element.children)
      }
    });

    return menu;
  }

}
